<template>
    <Dialog :open="open" @update:open="handleClose">
        <DialogContent class="sm:max-w-md">
            <DialogHeader>
                <DialogTitle class="text-destructive">Remove team member</DialogTitle>
            </DialogHeader>

            <div class="space-y-4">
                <p class="text-sm text-muted-foreground">
                    You are about to remove
                    <span class="font-medium text-foreground">{{ member?.name }}</span>
                    ({{ member?.email }}) from team
                    <span class="font-medium text-foreground">{{ team.name }}</span>.
                </p>

                <p v-if="!team.personal_team" class="text-sm text-muted-foreground">
                    This member will lose access to all team templates.
                </p>
            </div>

            <DialogFooter class="mt-4">
                <Button size="lg" variant="ghost" @click="handleClose">
                    Cancel
                </Button>
                <Button
size="lg"
                    variant="destructive"
                    :disabled="loading"
                    :loading="loading"
                    @click="$emit('remove')"
                >
                    Remove member
                </Button>
            </DialogFooter>
        </DialogContent>
    </Dialog>
</template>

<script setup lang="ts">
import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import IUser from '@/types/Members/IUser'
import ICurrentTeam from '@/types/Members/ICurrentTeam'

defineProps<{
    open: boolean
    member?: IUser
    team: ICurrentTeam
    loading: boolean
}>()

const emit = defineEmits<{
    close: []
    remove: []
}>()

const handleClose = () => {
    emit('close')
}
</script>
